import React from 'react'
import PropTypes from 'prop-types'
import Swiper from '../Swiper'

const params = {
  resistance: false,
  speed: 800,
  loop: false
}

const ImageSwiper = ({ images }) => {
  const onImageLoad = (e) => {
    const imageWidth = e.target.naturalWidth
    const imageHeight = e.target.naturalHeight
    if (imageHeight > imageWidth) {
      e.target.classList.add('small-width')
    }
  }
  return (
    <Swiper
      {...params}
      id='swiper'
      classNames={['in_product-card__image']}
    >
      {images && images.map((image, index) => (
        <div className='slide' key={index}>
          <img height='100%' width='100%' onLoad={e => onImageLoad(e)} src={image} role='presentation' />
        </div>
      ))}
    </Swiper>
  )
}

ImageSwiper.propTypes = {
  images: PropTypes.array
}

export default ImageSwiper



// WEBPACK FOOTER //
// ./src/templates/insta/components/products/ImageSwiper.js